import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, mergeMap, Observable, shareReplay } from 'rxjs';
import { COUNTRY_ID } from 'src/app/shared/constants/local-storage-items.constants';
import { JobType, JobTypes } from 'src/app/shared/models/job-types.model';
import { MasterDataService } from '../http/master-data/master-data.service';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class JobTypesService {
  constructor(
    private masterDataSvc: MasterDataService,
    private http: HttpClient,
    private localStorageService: LocalStorageService
  ) {}

  getJopTypes(): Observable<JobTypes[]> {
    return this.getAllJopTypes().pipe(
      map((res: any[]) => {
        return this.mapJobTypes(res);
      })
    );
  }

  private getAllJopTypes() {
    return this.masterDataSvc
      .getActiveJobTypeVersion()
      .pipe(mergeMap((uri) => this.getJobTypesJson(uri)));
  }

  private jobTypeJson$: Observable<any>;
  private getJobTypesJson(uri: string) {
    if (!this.jobTypeJson$) {
      this.jobTypeJson$ = this.http.get<any>(uri).pipe(shareReplay(1));
    }
    return this.jobTypeJson$;
  }

  private mapJobTypes(res: any) {
    res = this.filterByCountryId(res);
    let allJobTypes = this.toJobType(res);
    const primaryJobTypes = this.primaryJobTypes(allJobTypes);
    const secondaryJobTypes = this.secondaryJobTypes(allJobTypes);
    return this.toJobTypes(primaryJobTypes, secondaryJobTypes);
  }

  private filterByCountryId(arr: any[]) {
    const preferedCountryId = this.localStorageService.get(COUNTRY_ID);
    return arr.filter(
      (element: { CountryId: string }) => element.CountryId == preferedCountryId
    );
  }

  private toJobType(arr: any[]) {
    let allJobTypes: JobType[] = [];
    arr.forEach((x) => {
      allJobTypes.push({
        id: x.Id,
        name: x.Name,
        parentId: x.ParentJobTypeId,
      });
    });

    return allJobTypes;
  }

  private primaryJobTypes(jobTypes: JobType[]) {
    return jobTypes.filter((element) => element.parentId == null);
  }

  private secondaryJobTypes(jobTypes: JobType[]) {
    return jobTypes.filter((element) => element.parentId != null);
  }

  private toJobTypes(primaryJobTypes: JobType[], secondaryJobTypes: JobType[]) {
    let jobTypes: JobTypes[] = [];
    primaryJobTypes.forEach((x) => {
      let subTypes = secondaryJobTypes.filter((y) => y.parentId == x.id);
      if (subTypes.length > 0) {
        jobTypes.push({
          primaryJobType: x,
          secondaryJobTypes: subTypes,
        });
      }
    });
    return jobTypes;
  }
}
